// import { createSlice } from "@reduxjs/toolkit";


// // Create slice
// const AttendanceSlice = createSlice({
//     name: "Attendance",
//     initialState: {
//       savefirstparty: [],
//       savewitness: [],
//       // isModifying: false,
//     },
//     reducers: {
//       setFirstPartyDetails: (state, action) => {
//         state.savefirstparty = action.payload;
//       },
//       setWitnessDetails: (state, action) => {
//         state.savewitness = action.payload;
//       },
  
//       updatePartyDetails: (state, action) => {
//         const { savefirstparty, savewitness } = action.payload;
//         state.savefirstparty = savefirstparty;
//         state.savewitness = savewitness;
//       },
  
//       resetPartyDetails: (state, action) => {
//         state.savefirstparty = state.initialState;
//         state.savewitness = state.initialState;
//       },
      
//     },

//   });
  
//   export const {
//     setFirstPartyDetails,
//     setWitnessDetails,
//     resetPartyDetails,
//     updatePartyDetails,
//   } = AttendanceSlice.actions;
  
//   export const selectFirstParty = (state) => state.PartyDetail.savefirstparty;
//   export const selectWitness = (state) => state.PartyDetail.savewitness;

//   export default AttendanceSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const initialFirstPartyData = JSON.parse(sessionStorage.getItem("firstPartyTableData")) || [];
const initialWitnessData = JSON.parse(sessionStorage.getItem("witnessTableData")) || [];

const AttendanceSlice = createSlice({
  name: "Attendance",
  initialState: {
    savefirstparty: initialFirstPartyData,
    savewitness: initialWitnessData,
  },
  reducers: {
    setFirstPartyDetails: (state, action) => {
      state.savefirstparty = action.payload;
      sessionStorage.setItem("firstPartyTableData", JSON.stringify(action.payload));
    },
    setWitnessDetails: (state, action) => {
      state.savewitness = action.payload;
      sessionStorage.setItem("witnessTableData", JSON.stringify(action.payload));
    },
    resetPartyDetails: (state) => {
      state.savefirstparty = [];
      state.savewitness = [];
      sessionStorage.removeItem("firstPartyTableData");
      sessionStorage.removeItem("witnessTableData");
    },
  },
});

export const {
  setFirstPartyDetails,
  setWitnessDetails,
  resetPartyDetails,
} = AttendanceSlice.actions;

export const selectFirstParty = (state) => state.Attendance.savefirstparty;
export const selectWitness = (state) => state.Attendance.savewitness;

export default AttendanceSlice.reducer;
